import { render, staticRenderFns } from "./setAccount.vue?vue&type=template&id=621be0b8&scoped=true"
import script from "./setAccount.vue?vue&type=script&lang=js"
export * from "./setAccount.vue?vue&type=script&lang=js"
import style0 from "./setAccount.vue?vue&type=style&index=0&id=621be0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621be0b8",
  null
  
)

export default component.exports